module.exports = __webpack_public_path__ + "assets/img/kv-2e1c11b2.jpg";